(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-custom-contact"] && !Shopify.designMode) return;
  try {
    
  /* LOCATION DATA */
  const LOCATIONS = [
    {
      name: 'Surbiton',
      address: 'Southborough High School, Hook road, Surbiton, Surrey, KT6 5AS',
      hours: 'Събота: 09:00 - 12:45 ч.',
      color: 'secondary',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d825.1710599001304!2d-0.3029003927635682!3d51.37580541662248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760a379a4b177b%3A0x2231227b96c68113!2sSouthborough%20High!5e1!3m2!1sbg!2sbg!4v1774284087601!5m2!1sbg!2sbg',
    },
    {
      name: 'Sutton - Фолклорна танцова група „Звънчета“',
      address: 'Trinity Church, Cheam road, Sutton, Surrey, SM1 1DZ',
      hours: 'Събота: 12:45 - 13:50 ч.',
      color: 'primary',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d657.2481863352943!2d-0.19379756415916655!3d51.3615563955061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487608110527099f%3A0xb86f941714c2efbe!2sTrinity%20Church%2C%20Sutton!5e1!3m2!1sbg!2sbg!4v1774284182744!5m2!1sbg!2sbg',
    },
    {
      name: 'Sutton - ПГ- 4 клас',
      address: 'Sutton College, St. Nicholas way, Sutton, Surrey, SM1 1AG',
      hours: 'Събота: 9:00 - 12:30 ч.',
      color: 'primary',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1145.0602294829696!2d-0.19572053025425004!3d51.3619606982363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876080e9a53ff6f%3A0xeb087a399ca876da!2sSutton%20College!5e1!3m2!1sbg!2sbg!4v1774284240857!5m2!1sbg!2sbg',
    },
    {
      name: 'Sutton - Училище (5-12 клас)',
      address: 'Harris Academy, 2 Chiltern road, Sutton, Surrey, SM2 5QP',
      hours: 'Събота: 13:30 - 15:45 ч.',
      color: 'primary',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4581.711337091136!2d-0.19602622210527854!3d51.34725547177738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487609a31bf7061f%3A0x707e1951d4fcaa59!2sHarris%20Academy%20Sutton!5e1!3m2!1sbg!2sbg!4v1774284300985!5m2!1sbg!2sbg',
    },
  ];

  /* FUNCTIONALITY */
  function initLocationsSlider(root, locations) {
    if (!root || root.dataset.locationsInit === '1') return;
    root.dataset.locationsInit = '1';

    if (!Array.isArray(locations) || locations.length === 0) return;

    const elName = root.querySelector('[data-loc-name]');
    const elAddress = root.querySelector('[data-loc-address]');
    const elHours = root.querySelector('[data-loc-hours]');
    const elIframe = root.querySelector('[data-loc-iframe]');
    const elDots = root.querySelector('[data-loc-dots]');
    const elCounter = root.querySelector('[data-loc-counter]');
    const btnPrev = root.querySelector('[data-loc-prev]');
    const btnNext = root.querySelector('[data-loc-next]');
    const header = root.querySelector('[data-loc-header]');

    let index = 0;
    let paused = false;
    let intervalId = null;

    const setHeaderTheme = (color) => {
      if (!header) return;
      header.classList.toggle('is-primary', color === 'primary');
      header.classList.toggle('is-secondary', color === 'secondary');
    };

    const renderDots = () => {
      if (!elDots) return;
      elDots.innerHTML = '';

      locations.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rw-dot';
        b.setAttribute('aria-label', `Go to location ${i + 1}`);
        b.addEventListener('click', () => {
          index = i;
          render();
          restartAuto();
        });
        elDots.appendChild(b);
      });
    };

    const render = () => {
      const loc = locations[index];
      if (!loc) return;

      if (elName) elName.textContent = loc.name || '';
      if (elAddress) elAddress.textContent = loc.address || '';
      if (elHours) elHours.textContent = loc.hours || '';

      if (elIframe && loc.mapUrl) {
        if (elIframe.getAttribute('src') !== loc.mapUrl) {
          elIframe.setAttribute('src', loc.mapUrl);
        }
      }

      setHeaderTheme(loc.color);

      if (elDots) {
        const dots = elDots.querySelectorAll('.rw-dot');
        const loc = locations[index];

        dots.forEach((d, i) => {
            const isActive = i === index;
            d.classList.toggle('is-active', isActive);

            if (isActive) {
            d.style.setProperty(
                '--rw-dot-color',
                loc.color === 'primary'
                ? 'var(--primary-color)'
                : 'var(--secondary-color)'
            );
            }
        });
        }

      if (elCounter) elCounter.textContent = `Локация ${index + 1} от ${locations.length}`;
    };

    const next = () => {
      index = (index + 1) % locations.length;
      render();
    };
    const prev = () => {
      index = (index - 1 + locations.length) % locations.length;
      render();
    };

    const startAuto = () => {
      if (intervalId) return;
      intervalId = window.setInterval(() => {
        if (!paused) next();
      }, 4000);
    };

    const stopAuto = () => {
      if (!intervalId) return;
      window.clearInterval(intervalId);
      intervalId = null;
    };

    const restartAuto = () => {
      stopAuto();
      startAuto();
    };

    if (btnNext)
      btnNext.addEventListener('click', () => {
        next();
        restartAuto();
      });
    if (btnPrev)
      btnPrev.addEventListener('click', () => {
        prev();
        restartAuto();
      });

    root.addEventListener('mouseenter', () => {
      paused = true;
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
    });

    renderDots();
    render();
    startAuto();

    // Theme Editor cleanup
    document.addEventListener('shopify:section:unload', (e) => {
      const section = root.closest('[data-shopify-section-id]');
      if (!section) return;
      if (section.dataset.shopifySectionId === e.detail.sectionId) stopAuto();
    });
  }

  function boot() {
    document.querySelectorAll('[data-locations-slider]').forEach((root) => {
      initLocationsSlider(root, LOCATIONS);
    });
  }

  // Run on load + when Theme Editor reloads a section
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-finance-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.finance-form[data-accordion]');
    if (!roots.length) return;

    roots.forEach((root) => {
      const btn = root.querySelector('[data-acc-trigger]');
      const panel = root.querySelector('[data-collapse]');
      const inner = root.querySelector('[data-collapse-inner]');
      if (!btn || !panel || !inner) return;

      let animating = false;

      const open = () => {
        if (animating) return;
        animating = true;

        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;

        panel.style.height = '0px';
        requestAnimationFrame(() => {
          panel.style.height = inner.scrollHeight + 'px';
        });

        const onEnd = (e) => {
          if (e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.style.height = 'auto';
          animating = false;
        };
        panel.addEventListener('transitionend', onEnd);
      };

      const close = () => {
        if (animating) return;
        animating = true;

        btn.setAttribute('aria-expanded', 'false');

        const start = inner.scrollHeight;
        panel.style.height = start + 'px';

        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });

        const onEnd = (e) => {
          if (e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.hidden = true;
          panel.style.height = '0px';
          animating = false;
        };
        panel.addEventListener('transitionend', onEnd);
      };

      // Init
      panel.style.height = '0px';
      panel.hidden = true;

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        expanded ? close() : open();
      });

      // If app content loads async while open, keep height correct during transition
      const ro = new ResizeObserver(() => {
        if (btn.getAttribute('aria-expanded') !== 'true') return;
        if (panel.style.height === 'auto') return;
        panel.style.height = inner.scrollHeight + 'px';
      });
      ro.observe(inner);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-school-plan"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // -----------------------------
    // Tab Controller Logic
    // -----------------------------
    const section = document.querySelector('.school-plan');
    const buttons = document.querySelectorAll('.school-plan__controller button');
    const tabs = document.querySelectorAll('.school-plan__tab-content');

    if (buttons.length && tabs.length) {
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const targetSchool = button.dataset.school;

          // 1. Update Section Classes for Theme Colors
          section.classList.remove('is-surbiton', 'is-sutton', 'is-online');
          section.classList.add(`is-${targetSchool}`);

          // 2. Toggle Active Buttons
          buttons.forEach(btn => btn.classList.remove('is-active'));
          button.classList.add('is-active');

          // 3. Toggle Active Tabs
          tabs.forEach(tab => {
            if (tab.dataset.school === targetSchool) {
              tab.classList.add('is-active');
            } else {
              tab.classList.remove('is-active');
            }
          });
        });
      });
    }

    // -----------------------------
    // Image Modal (Lightbox) Logic
    // -----------------------------
    const modal = document.getElementById('calendarModal');
    const modalImg = document.getElementById('calendarModalImg');
    const closeBtn = document.getElementById('calendarModalClose');
    const zoomableImages = document.querySelectorAll('.zoomable-calendar');

    if (modal && modalImg && zoomableImages.length) {
      // Open modal on image click
      zoomableImages.forEach(img => {
        img.addEventListener('click', function() {
          modal.classList.add('is-open');
          modalImg.src = this.src;
        });
      });

      // Function to close modal
      const closeModal = () => {
        modal.classList.remove('is-open');
        setTimeout(() => { modalImg.src = ""; }, 300); // Clear image src after transition
      };

      // Close on X click
      closeBtn.addEventListener('click', closeModal);

      // Close on clicking outside the image or on the image itself
      modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target === modalImg) {
          closeModal();
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-sign-up"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-enrollment-tabs] [data-category]');
  if (!btn) return;

  const root = btn.closest('[data-enrollment-tabs]');
  if (!root) return;

  const category = btn.dataset.category;

  root.querySelectorAll('[data-category]').forEach((b) => {
    const active = b.dataset.category === category;
    b.classList.toggle('enrollment-choice-active', active);
    b.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  const section = root.closest('.enrollment');
  if (section) {
    section.querySelectorAll('[data-panel]').forEach((p) => {
      const active = p.dataset.panel === category;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
  }

  document.querySelectorAll('.important-info__content[id]').forEach((infoDiv) => {
    const isActive = infoDiv.id === `important-info__${category}`;
    infoDiv.hidden = !isActive;
    infoDiv.classList.toggle('is-active', isActive); 
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-special-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const data = window.enrollmentProducts || {};
  const schoolSelect = document.getElementById('school-select');
  const gradeSelect = document.getElementById('grade-select');
  const handleInput = document.getElementById('enrollment-handle');
  const addButton = document.getElementById('add-enrollment-btn');

  if (!schoolSelect || !gradeSelect || !handleInput || !addButton) return;

  function resetGrades() {
    gradeSelect.innerHTML = '<option value="">Select Grade</option>';
    gradeSelect.disabled = true;
    gradeSelect.value = '';
    handleInput.value = '';
    addButton.disabled = true;
  }

  function populateSchools() {
    schoolSelect.innerHTML = '<option value="">Select School</option>';

    Object.entries(data).forEach(([schoolKey, schoolData]) => {
      const option = document.createElement('option');
      option.value = schoolKey;
      option.textContent = schoolData.label || schoolKey;
      schoolSelect.appendChild(option);
    });
  }

  function populateGrades(schoolKey) {
    resetGrades();

    if (!schoolKey || !data[schoolKey] || !data[schoolKey].grades) return;

    Object.entries(data[schoolKey].grades).forEach(([gradeKey, gradeData]) => {
      const option = document.createElement('option');
      option.value = gradeKey;
      option.textContent = gradeData.label || gradeKey;
      gradeSelect.appendChild(option);
    });

    gradeSelect.disabled = false;
  }

  schoolSelect.addEventListener('change', () => {
    populateGrades(schoolSelect.value);
  });

  gradeSelect.addEventListener('change', () => {
    const schoolKey = schoolSelect.value;
    const gradeKey = gradeSelect.value;
    const handle = data[schoolKey]?.grades?.[gradeKey]?.handle || '';

    handleInput.value = handle;
    addButton.disabled = !handle;
  });

  addButton.addEventListener('click', async () => {
    const handle = handleInput.value;

    if (!handle) {
      alert('Please select a school and grade first.');
      return;
    }

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    try {
      const productResponse = await fetch(`/products/${handle}.js`);

      if (!productResponse.ok) {
        throw new Error('Could not load product.');
      }

      const product = await productResponse.json();
      const variant = product.variants.find(v => v.available) || product.variants[0];

      if (!variant) {
        throw new Error('No variant found for this product.');
      }

      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1
        })
      });

      if (!cartResponse.ok) {
        throw new Error('Could not add product to cart.');
      }

      const addedItem = await cartResponse.json();
      console.log('Added to cart:', addedItem);

      addButton.textContent = 'Added';
      
      setTimeout(() => {
        addButton.textContent = 'Add Enrollment';
        addButton.disabled = false;
      }, 1200);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      console.error(error);
      alert(error.message || 'Something went wrong.');

      addButton.textContent = 'Add Enrollment';
      addButton.disabled = false;
    }
  });

  populateSchools();
  resetGrades();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
